import theme from "@shared/utils/themeColors";
import AuthenticatedLayout from "../../../shared/layouts/AuthenticatedLayout";
import AccountSection from "../components/AccountSection";
import SettingsSidebar from "../components/SettingsSidebar";

export default function SettingsPage() {
  return (
    <AuthenticatedLayout>
      <div className="px-4 sm:px-6 lg:px-8 py-8 w-full max-w-9xl mx-auto">
        {/* Page header */}
        <div className="mb-8">
          {/* Title */}
          <h1
            className={`text-2xl md:text-3xl ${theme.text.primary} font-bold`}
          >
            Account Settings
          </h1>
        </div>

        {/* Content */}
        <div className={`${theme.bg.primary} shadow-sm rounded-xl mb-8`}>
          <div className="flex flex-col md:flex-row md:-mr-px">
            <SettingsSidebar />
            <AccountSection />
          </div>
        </div>
      </div>
    </AuthenticatedLayout>
  );
}
